import * as React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';

import GoogleAuthButton from '../../../components/GoogleAuthButton';
import { ReactComponent as EmailIcon } from '../../../assets/icons/email.svg';
import AppleAuthButton from '../../../components/AppleAuthButton';

// Email button

const EmailButtonContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 48px;
  width: 240px;
  :hover {
    box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2);
  }
  transition: all 400ms ease 0s;
  border: 1px solid ${themes.colors.KBGrey};
`;

const EmailIconStyled = styled(EmailIcon)`
  box-sizing: content-box;
  padding-left: 14px;
  padding-right: 34px;
`;

const EmailText = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 16px;
  color: ${themes.colors.KBNight};
`;

const EmailButton = (props: { onClick: (e: React.MouseEvent) => void }) => {
  return (
    <EmailButtonContainer onClick={props.onClick}>
      <EmailIconStyled />
      <EmailText>Sign up with email</EmailText>
    </EmailButtonContainer>
  );
};

const GoogleWrapper = styled.div`
  padding-bottom: 24px;
`;

const ForgotPasswordLink = styled.a`
  cursor: pointer;
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding-top: 28px;
  padding-bottom: 28px;
  text-decoration: underline;
  color: ${themes.colors.KBNight};
`;

// Sign Up Buttons

type Props = {
  onSignUpWithEmail: () => void;
  onSignUpWithApple: () => void;
  onHaveAnAccount: () => void;
};

const SignUpButtonOptions = (props: Props) => {
  return (
    <React.Fragment>
      <GoogleWrapper>
        <GoogleAuthButton type={'light'} context="signup" />
      </GoogleWrapper>
      <GoogleWrapper>
        <AppleAuthButton operation="signUp" />
      </GoogleWrapper>

      <EmailButton onClick={props.onSignUpWithEmail} />
      <ForgotPasswordLink onClick={props.onHaveAnAccount}>
        Already have an account?
      </ForgotPasswordLink>
    </React.Fragment>
  );
};

export default SignUpButtonOptions;
